import { NavLink } from 'react-router-dom';

import { ART } from '../../components/Idle/sidebarArt';
import Coin from '../../components/Idle/Coin';
import GemIcon from '../../components/Idle/GemIcon';
import Kit from '../../components/Idle/Homely.module.css';
import { GEM_UPGRADES, UPGRADES, isUnlocked } from '../../lib/idle/gameConfig';
import { formatCoins } from '../../lib/idle/format';
import { buyUpgrade, useIdle } from '../../lib/idle/idleStore';
import { usePremium } from '../../lib/session';
import { useUI } from '../../lib/ui';

const RowIcon = ({ u }) => {
  if (u.kind === 'building') {
    const Art = ART[u.building];
    return <Art className={Kit.rowArt} />;
  }
  if (u.currency === 'gems') return <GemIcon size={28} />;
  return <span>×2</span>;
};

const Upgrades = () => {
  const state = useIdle();
  const premium = usePremium();
  const openPricing = useUI((s) => s.openPricing);

  const coinUpgrades = UPGRADES.filter(
    (u) => u.currency === 'coins' && !state.bought[u.id] && isUnlocked(u, state),
  ).sort((a, b) => a.cost - b.cost);

  return (
    <div className={Kit.page}>
      <div className={Kit.sheet}>
        <h1 className={Kit.heading}>Upgrades</h1>
        <p className={Kit.sub}>Coins buy the everyday stuff. Gems buy the good stuff.</p>

        <h2 className={Kit.sectionTitle}>Spend coins</h2>
        {coinUpgrades.length === 0 ? (
          <p className={Kit.empty}>Nothing new on the shelf. Answer a few more cards, hire a helper, check back.</p>
        ) : (
          <ul className={Kit.list}>
            {coinUpgrades.map((u) => (
              <li key={u.id} className={Kit.row}>
                <span className={Kit.rowIcon}>
                  <RowIcon u={u} />
                </span>
                <span className={Kit.rowText}>
                  <h3 className={Kit.rowName}>{u.name}</h3>
                  <p className={Kit.rowDesc}>{u.desc}</p>
                  <p className={Kit.rowPrice}>
                    <Coin size={16} /> {formatCoins(u.cost)}
                  </p>
                </span>
                <button
                  type="button"
                  className={Kit.buy}
                  disabled={state.coins < u.cost}
                  onClick={() => buyUpgrade(u.id)}
                >
                  Buy!
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>

      <div className={Kit.sheet}>
        <h2 className={Kit.sectionTitle}>
          Spend gems <GemIcon size={26} /> {formatCoins(state.gems)}
        </h2>
        <p className={Kit.sub}>
          Gems come from finishing full Scales sessions.
          {!premium && ' Scales is a Premium feature.'}
        </p>
        {!premium && (
          <p>
            <button
              type="button"
              className={Kit.ghostBtn}
              onClick={() => openPricing('Scale practice earns the Gems that buy these upgrades.')}
            >
              See Premium
            </button>
          </p>
        )}

        <ul className={Kit.list}>
          {GEM_UPGRADES.map((u) => {
            const owned = state.bought[u.id];
            return (
              <li key={u.id} className={Kit.row}>
                <span className={Kit.rowIcon}>
                  <GemIcon size={28} />
                </span>
                <span className={Kit.rowText}>
                  <h3 className={Kit.rowName}>{u.name}</h3>
                  <p className={Kit.rowDesc}>{u.desc}</p>
                  {!owned && (
                    <p className={Kit.rowPrice}>
                      <GemIcon size={16} /> {u.cost}
                    </p>
                  )}
                </span>
                {owned ? (
                  <span className={Kit.owned}>Owned</span>
                ) : (
                  <button
                    type="button"
                    className={Kit.buy}
                    disabled={state.gems < u.cost}
                    onClick={() => buyUpgrade(u.id)}
                  >
                    Buy!
                  </button>
                )}
              </li>
            );
          })}
        </ul>
        <p className={Kit.footnote}>
          Paper themes switch on when you buy them. You can swap back in Settings.{' '}
          <NavLink to="/cosmetics">Looking for valve felts and inlays?</NavLink>
        </p>
      </div>
    </div>
  );
};

export default Upgrades;